import { Component, EventEmitter, HostListener, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AdmissionsService } from 'src/app/core/services/admissions.service';import { take } from 'rxjs';

export const STAGE_OPTIONS: { display: string; value: string }[] = [
  { display: 'New', value: 'new' },
  { display: 'Contacting', value: 'contacting' },
  { display: 'Reached', value: 'reached' },
  { display: 'Nurture', value: 'nurture' },
  { display: 'Disqualified', value: 'disqualified' },
  { display: 'Prospecting', value: 'prospecting' },
  { display: 'Scheduled', value: 'scheduled' },
  { display: 'Recovery', value: 'recovery' },
  { display: 'Salvage', value: 'salvage' },
  { display: 'Lost', value: 'lost' },
  { display: 'Onboarded', value: 'onboarded' },
  { display: 'Qualified', value: 'qualified' },
  { display: 'Planned', value: 'planned' },
  { display: 'Achieved', value: 'achieved' },
  { display: 'Unqualified', value: 'unqualified' }
];

@Component({
  selector: 'app-stage-activity',
  templateUrl: './stage-activity.component.html',
  styleUrls: ['./stage-activity.component.scss']
})
export class StageActivityComponent implements OnInit, OnChanges {
  @Input() patientId = '';
  @Input() loggedInUserName = '';
  @Input() initialStage: string | null = null;
  @Output() stageSent = new EventEmitter<void>();
  @Output() stageCancelled = new EventEmitter<void>();

  stages = STAGE_OPTIONS;
  selectedStage: string | null = null;
  note = '';
  showStageDropdown = false;
  isSending = false;

  constructor(
    private readonly _admissionsService: AdmissionsService) {}

  ngOnInit(): void {
    if (this.initialStage) {
      this.selectedStage = this.initialStage;
      this.showStageDropdown = false;
    } else {
      this.showStageDropdown = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialStage'] && this.initialStage) {
      this.selectedStage = this.initialStage;
      this.showStageDropdown = false;
    }
  }

  get showPlusButton(): boolean {
    return !this.selectedStage;
  }

  toggleStageDropdown(): void {
    this.showStageDropdown = !this.showStageDropdown;
  }

  selectStage(value: string): void {
    this.selectedStage = value;
    this.showStageDropdown = false;
  }

  removeStage(): void {
    this.selectedStage = null;
    this.stageCancelled.emit();
  }

  getStageDisplay(value: string): string {
    return this.stages.find(s => s.value === value)?.display ?? value;
  }

  canSend(): boolean {
    return !!this.selectedStage && !!this.patientId && !this.isSending;
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.showStageDropdown = false;
  }

  send(): void {
    if (!this.canSend()) return;

    this.isSending = true;
    this._admissionsService.logEngageStageActivity(
      this.patientId,
      this.selectedStage!,
      this.loggedInUserName,
      this.note.trim()
    ).pipe(take(1)).subscribe({
      next: () => {
this.stageSent.emit();
        this.selectedStage = null;
        this.note = '';
        this.isSending = false;
      },
      error: (err) => {
        this.isSending = false;
        if (err?.message?.toLowerCase().includes('referral not found') ||
            err?.error?.message?.toLowerCase().includes('referral not found')) {
} else {
}
      }
    });
  }
}
